<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
  <mat-form-field class="custom-date-picker" appearance="outline">
    <input type="hidden" placeholder="Month" [matDatepicker]="picker1" [value]="date1"
           (dateChange)="selectWeek($event.value, picker1, 1)"/>
    <input matInput type="text" [matTooltip]="pickerTooltip(date1!)" [value]="pickerDisplayValue(date1!)"/>
    <mat-datepicker-toggle matIconSuffix [for]="picker1">
      <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker #picker1 [startView]="getPickerStartView"
                    [panelClass]="calendarPanelClass"
                    [dateClass]="weekHighlightFor(1)"
                    (yearSelected)="selectYear($event, picker1, 1)"
                    (monthSelected)="selectMonth($event, picker1, 1)"></mat-datepicker>
  </mat-form-field>

  <div class="body-1-regular-2">and</div>

  <mat-form-field class="custom-date-picker" appearance="outline">
    <input type="hidden" placeholder="Month" [matDatepicker]="picker2" [value]="date2"
           (dateChange)="selectWeek($event.value, picker2, 2)"/>
    <input matInput type="text" [matTooltip]="pickerTooltip(date2!)" [value]="pickerDisplayValue(date2!)"/>
    <mat-datepicker-toggle matIconSuffix [for]="picker2">
      <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker #picker2 [startView]="getPickerStartView"
                    [panelClass]="calendarPanelClass"
                    [dateClass]="weekHighlightFor(2)"
                    (yearSelected)="selectYear($event, picker2, 2)"
                    (monthSelected)="selectMonth($event, picker2, 2)"></mat-datepicker>
  </mat-form-field>
</div>
